<template>
    <b-form @submit.prevent="tryToLogin">
        <b-form-group label="OTP" label-for="otp">
            <b-form-input
                id="otp"
                ref="otpInput"
                v-model="otp"
                type="text"
                placeholder="Enter OTP"
                :class="{
                    'is-invalid': hasError('otp')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('otp') }}
            </div>
        </b-form-group>

        <b-alert
            v-if="otpError"
            show
            dismissible
            variant="danger"
            class="text-center"
        >
            {{ otpError }}
        </b-alert>

        <b-form-group class="mt-4">
            <b-button
                type="submit"
                variant="primary"
                class="btn-block"
                :disabled="inProgress"
            >
                Login
            </b-button>
        </b-form-group>
    </b-form>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { StatusCodes as HTTP } from 'http-status-codes';

export default {
    props: {
        phone: {
            type: String,
            required: true
        }
    },

    validations: {
        otp: {
            required
        }
    },

    data() {
        return {
            otp: '',
            otpError: '',
            inProgress: false,
            serverErrors: []
        };
    },

    mounted() {
        this.$refs.otpInput.focus();
    },

    methods: {
        ...mapActions({
            login: 'auth/login'
        }),

        async tryToLogin() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            this.inProgress = true;
            this.otpError = '';

            try {
                await this.$recaptchaLoaded();
                const token = await this.$recaptcha('login');

                await this.login({ phone: this.phone, otp: this.otp, token });

                const { redirectFrom = '/' } = this.$route.query;
                const redirectRoute = !['/logout', '/login'].includes(
                    redirectFrom
                )
                    ? redirectFrom
                    : { name: 'dashboard' };

                this.$router.push(redirectRoute);
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (data && data.error) {
                        this.otpError = data.error;

                        return;
                    }

                    if ([401, 403, 404].includes(status)) {
                        this.otpError = 'Wrong OTP.';

                        return;
                    }

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            } finally {
                this.inProgress = false;
            }
        },

        hasError(key) {
            return (
                this.$v[key].$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.$v,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
